<template>
  <main class="profile edit bb">
    <PageHeaderSection />

    <GeneralInfoSection />

    <AppSettingsSection />

    <OtherSettingsSection />
  </main>
</template>

<script setup>
import PageHeaderSection from '@/views/profileEdit/components/section/PageHeaderSection.vue';
import GeneralInfoSection from '@/views/profileEdit/components/section/GeneralInfoSection.vue';
import AppSettingsSection from '@/views/profileEdit/components/section/AppSettingsSection.vue';
import OtherSettingsSection from '@/views/profileEdit/components/section/OtherSettingsSection.vue';
</script>
